import { useTranslation } from '@mint-lib/i18n';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { MarkdownTextUser } from './Markdown/MarkdownText.jsx';

type Props = {
  text: string;
  isCancelled?: boolean;
};

const UserMessage = ({ text, isCancelled }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <Card
      variant="outlined"
      className="w-full bg-ui-tertiary"
      data-testid="user-message"
      contentClassName={cn(
        'relative flex w-full flex-col gap-2 overflow-visible',
        isCancelled
          ? 'before:pointer-events-none before:absolute before:inset-0 before:z-1 before:bg-ui-primary/50'
          : '',
      )}
    >
      <div className="flex items-baseline gap-1">
        <div
          className={cn(
            'w-full wrap-break-word whitespace-pre-wrap',
            typographyVariants({ variant: 'bodyLong01' }),
          )}
        >
          <MarkdownTextUser text={text} />
        </div>
      </div>
      {isCancelled && (
        <div
          className={cn(
            'relative z-2',
            typographyVariants({ variant: 'bodyShort02' }),
          )}
        >
          {t('This request was stopped')}
        </div>
      )}
    </Card>
  );
};

export { UserMessage };
